import cn from 'clsx'
import { StyleFormGroup } from './style'

const FormGroup = ({ className, children, ...restProps }) => {
  return (
    <StyleFormGroup className={cn('form-group', className)} {...restProps}>
      {children}
    </StyleFormGroup>
  )
}

export default FormGroup
